// import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all';

if (module.hot) {
  module.hot.accept();
}

/* Holland Web Development Additional Javascript */
jQuery(function($){
	
	$(document).ready(function(){
		/* Tooltip Addition */
		$('[data-toggle="tooltip"]').tooltip();
		
		/* Height Adjustment */
		$('body').each(function(){
			
			var highestBox = 0;
			
			$('.py-5', this).each(function(){
				if($(this).height() > highestBox){
					highestBox = $(this).height();
				}
			});
			
			$('.py-5', this).each(function(){
				if($(this).height() < highestBox){
					var paddingAdjustment = highestBox - $(this).height();
					$(this).css('margin-bottom', paddingAdjustment);
				}
			});

		});
		
		/* Initial Slide Setup */
		$(".mainSlides").hide(); 
		$("#slide1").show();
		
		/* Slide 1 */
		$("a.slide1Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide2" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 2 */
		$("a.slide2Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide1" ).show();
			
			e.preventDefault();
		});
		$("a.slide2Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide3" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 3 */
		$("a.slide3Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide2" ).show();
			
			e.preventDefault();
		});
		$("a.slide3Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide4" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 4 */
		$("a.slide4Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide3" ).show();
			
			e.preventDefault();
		});
		$("a.slide4Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide5" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 5 */
		$("a.slide5Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide4" ).show();
			
			e.preventDefault();
		});
		$("a.slide5Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide6" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 6 */
		$("a.slide6Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide5" ).show();
			
			e.preventDefault();
		});
		$("a.slide6Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide7" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 7 */
		$("a.slide7Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide6" ).show();
			
			e.preventDefault();
		});
		$("a.slide7Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide8" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 8 */
		$("a.slide8Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide7" ).show();
			
			e.preventDefault();
		});
		$("a.slide8Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide9" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 9 */
		$("a.slide9Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide8" ).show();
			
			e.preventDefault();
		});
		$("a.slide9Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide10" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 10 */
		$("a.slide10Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide9" ).show();
			
			e.preventDefault();
		});
		$("a.slide10Next").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide11" ).show();
			
			e.preventDefault();
		});
		
		/* Slide 11 */
		$("a.slide11Prev").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide10" ).show();
			
			e.preventDefault();
		});
		
		/* Header Navigation Jump Function */
		$("a.jumpSlide1").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide1" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide2").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide2" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide3").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide3" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide4").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide4" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide5").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide5" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide6").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide6" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide7").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide7" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide8").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide8" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide9").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide9" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide10").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide10" ).show();
			
			e.preventDefault();
		});
		
		$("a.jumpSlide11").click(function(e){
			$( ".mainSlides" ).hide();
			$( "#slide11" ).show();
			
			e.preventDefault();
		});
		
		
		/* Get URL Paramaters */
		$.urlParam = function(name){
			var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
			return results[1] || 0;
		}
		
		if($.urlParam('slide') == '1'){
			$( ".mainSlides" ).hide();
			$( "#slide1" ).show();
		}
		if($.urlParam('slide') == '2'){
			$( ".mainSlides" ).hide();
			$( "#slide2" ).show();
		}
		if($.urlParam('slide') == '3'){
			$( ".mainSlides" ).hide();
			$( "#slide3" ).show();
		}
		if($.urlParam('slide') == '4'){
			$( ".mainSlides" ).hide();
			$( "#slide4" ).show();
		}
		if($.urlParam('slide') == '5'){
			$( ".mainSlides" ).hide();
			$( "#slide5" ).show();
		}
		if($.urlParam('slide') == '6'){
			$( ".mainSlides" ).hide();
			$( "#slide6" ).show();
		}
		if($.urlParam('slide') == '7'){
			$( ".mainSlides" ).hide();
			$( "#slide7" ).show();
		}
		if($.urlParam('slide') == '8'){
			$( ".mainSlides" ).hide();
			$( "#slide8" ).show();
		}
		if($.urlParam('slide') == '9'){
			$( ".mainSlides" ).hide();
			$( "#slide9" ).show();
		}
		if($.urlParam('slide') == '10'){
			$( ".mainSlides" ).hide();
			$( "#slide10" ).show();
		}
		if($.urlParam('slide') == '11'){
			$( ".mainSlides" ).hide();
			$( "#slide11" ).show();
		}
		
	});
});